export default "/images/4ccfaffbfa5f4eab37c43a3405503368.avif";